import { api } from "./client";
import type { DailyReflection, DailyVerse } from "./types";

/** docs/API_CONTRACT.md - GET /api/admin/daily/verse/current */
export function getCurrentDailyVerse(): Promise<DailyVerse> {
  return api.get<DailyVerse>("/admin/daily/verse/current");
}

/** docs/API_CONTRACT.md - GET /api/admin/daily/reflection/current */
export function getCurrentDailyReflection(): Promise<DailyReflection> {
  return api.get<DailyReflection>("/admin/daily/reflection/current");
}

export const REFLECTION_CAPABILITIES = {
  edit: false,
  regenerate: true,
  restoreAutomatic: false,
} as const;

export function updateDailyReflection(body: string): Promise<DailyReflection> {
  return api.put<DailyReflection>("/admin/daily/reflection/manual-override", { body });
}

export function regenerateDailyReflection(): Promise<DailyReflection> {
  return api.post<DailyReflection>("/admin/daily/reflection/regenerate");
}

export function restoreAutomaticDailyReflection(): Promise<DailyReflection> {
  return api.post<DailyReflection>("/admin/daily/reflection/restore-automatic");
}
